import styled from 'styled-components'
import { ContentHeader } from '../App'
import Item from './Confirmation/Item'
import Heading from './Heading'
import { useContext, useEffect, useRef } from 'react'
import { OrderItemsContext } from '../context/OrderItemsContext'
import { OrderDataContext } from '../context/OrderDataContext'
import { ErrorContext } from "../context/ErrorContext";
import { MenuContext } from "../context/MenuContext";
import { Text } from '@chakra-ui/react'
import { TranslationContext } from '../context/TranslationContext'

function CookingPage ({ page }) {
    const myRef = useRef(null)
    const { orderItems } = useContext(OrderItemsContext)
    const { order } = useContext(OrderDataContext)
    const { errors } = useContext(ErrorContext)
    const { menu } = useContext(MenuContext)
    const { translations } = useContext(TranslationContext)

    useEffect(() => {
        if (errors?.time || errors?.location) {
            myRef.current.scrollIntoView()
        }
    }, [errors])

    return (
        <Wrapper>
            <ContentHeader>
                <Heading page={page} />
                {Object.keys(orderItems).length > 0 ?
                    <Order>
                        {Object.keys(orderItems).map(key =>
                            <Item
                                key={key}
                                id={key}
                                quantity={orderItems[key].quantity}
                                items={menu}
                                children={orderItems[key].children}
                            />
                        )}
                    </Order> : <Order>{translations.table_book_only}</Order>
                }
                {order.comment ? <Text mt={4}>{order.comment}</Text> : null}
            </ContentHeader>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
`

const Order = styled.div`
    background: #F4F4F4;
    border-radius: 10px;
    padding: 15px;
    margin-top: 40px;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.19);
`

export default CookingPage;
